(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      if (typeof setupHeaderAnnouncementLayout === 'function') {
        setupHeaderAnnouncementLayout();
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerBar = this.header.querySelector('.header');
      const height = headerBar?.offsetHeight || this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      if (typeof setupHeaderAnnouncementLayout === 'function') {
        setupHeaderAnnouncementLayout();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function syncHeaderAppearanceFromHero() {
    const wrapper = document.querySelector('.section-header .header-wrapper');
    if (!wrapper) return;

    const main = document.getElementById('MainContent');
    if (!main) return;
    const firstSection = main.querySelector('.shopify-section');
    wrapper.classList.remove('header-theme--light', 'header-theme--dark');
    if (!firstSection) return;
    const marker = firstSection.querySelector('[data-header-appearance]');
    const mode = marker ? marker.getAttribute('data-header-appearance') : 'auto';
    if (mode === 'light') {
      wrapper.classList.add('header-theme--light');
    } else if (mode === 'dark') {
      wrapper.classList.add('header-theme--dark');
    }
  }

  function setupHeaderScrollBackground() {
    if (window.__headerScrollBackgroundInitialized) return;

    const sectionHeader = document.querySelector('.section-header');
    const wrapper = sectionHeader ? sectionHeader.querySelector('.header-wrapper') : null;
    if (!wrapper) return;

    const SCROLL_BG_THRESHOLD_PX = 50;

    const updateHeaderBackgroundState = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldActivate = scrollTop >= SCROLL_BG_THRESHOLD_PX;
      wrapper.classList.toggle('header-wrapper--scrolled', shouldActivate);
    };

    updateHeaderBackgroundState();
    window.addEventListener('scroll', updateHeaderBackgroundState, { passive: true });
    window.addEventListener('resize', updateHeaderBackgroundState);
    window.__headerScrollBackgroundInitialized = true;
  }

  const HEADER_ANNOUNCEMENT_SCROLL_THRESHOLD_PX = 8;

  function getSiteHeaderGroup() {
    return document.getElementById('SiteHeader');
  }

  function resolveHeaderGroupSection(node) {
    if (!node) return null;
    if (node.classList.contains('shopify-section-group-header-group')) return node;
    return node.closest('.shopify-section-group-header-group');
  }

  function updateSiteHeaderGroupHeight(siteHeaderGroup, headerNode) {
    if (!siteHeaderGroup?.classList.contains('header-sticky-overlay-context') || !headerNode) return;

    const announcementHeight =
      parseFloat(getComputedStyle(siteHeaderGroup).getPropertyValue('--announcement-bar-height')) || 0;
    const headerHeight =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) ||
      headerNode.querySelector('.header')?.offsetHeight ||
      headerNode.offsetHeight ||
      0;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const announcementAbove = siteHeaderGroup.classList.contains('header-group--announcement-above');
    const announcementBelow = siteHeaderGroup.classList.contains('header-group--announcement-below');

    let reservedHeight = headerHeight;
    if (announcementAbove && scrollTop < announcementHeight) {
      reservedHeight += announcementHeight;
    } else if (announcementBelow) {
      reservedHeight += announcementHeight;
    }

    siteHeaderGroup.style.setProperty('--site-header-group-height', `${reservedHeight}px`);
  }

  function isAnnouncementAboveHeader(announcementNode, headerNode, siteHeaderGroup) {
    const groupSections = Array.from(
      siteHeaderGroup.querySelectorAll('.shopify-section-group-header-group')
    );
    const announcementIndex = groupSections.indexOf(announcementNode);
    const headerIndex = groupSections.indexOf(headerNode);

    if (announcementIndex !== -1 && headerIndex !== -1) {
      return announcementIndex < headerIndex;
    }

    return Boolean(announcementNode.compareDocumentPosition(headerNode) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function setupHeaderAnnouncementLayout() {
    const siteHeaderGroup = getSiteHeaderGroup();
    if (!siteHeaderGroup) return;

    const announcementNode = resolveHeaderGroupSection(
      siteHeaderGroup.querySelector('.announcement-bar-section')
    );
    const headerNode = resolveHeaderGroupSection(
      siteHeaderGroup.querySelector('.shopify-section.section-header') ||
        siteHeaderGroup.querySelector('.section-header')
    );

    siteHeaderGroup.classList.remove('header-group--announcement-above', 'header-group--announcement-below');
    headerNode?.classList.remove('header-below-announcement');

    if (!announcementNode || !headerNode) {
      siteHeaderGroup.style.removeProperty('--announcement-bar-height');
      siteHeaderGroup.style.removeProperty('--site-header-group-height');
      headerNode?.style.removeProperty('top');
      return;
    }

    if (isAnnouncementAboveHeader(announcementNode, headerNode, siteHeaderGroup)) {
      siteHeaderGroup.classList.add('header-group--announcement-above');
      const announcementHeight = announcementNode.offsetHeight;
      siteHeaderGroup.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);

      headerNode.style.removeProperty('top');
      updateHeaderAnnouncementScrollOffset(siteHeaderGroup, headerNode);
      updateSiteHeaderGroupHeight(siteHeaderGroup, headerNode);
    } else {
      siteHeaderGroup.classList.add('header-group--announcement-below');
      siteHeaderGroup.style.setProperty('--announcement-bar-height', `${announcementNode.offsetHeight}px`);
      headerNode.style.removeProperty('top');
      updateSiteHeaderGroupHeight(siteHeaderGroup, headerNode);
    }
  }

  function updateHeaderAnnouncementScrollOffset(siteHeaderGroup, headerNode) {
    if (!siteHeaderGroup || !headerNode) return;
    if (!siteHeaderGroup.classList.contains('header-group--announcement-above')) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const announcementHeight =
      parseFloat(getComputedStyle(siteHeaderGroup).getPropertyValue('--announcement-bar-height')) || 0;
    const isStickyOverlayContext = siteHeaderGroup.classList.contains('header-sticky-overlay-context');
    const offsetThreshold = isStickyOverlayContext
      ? announcementHeight
      : HEADER_ANNOUNCEMENT_SCROLL_THRESHOLD_PX;

    headerNode.classList.toggle('header-below-announcement', scrollTop < offsetThreshold);
    updateSiteHeaderGroupHeight(siteHeaderGroup, headerNode);
  }

  const HEADER_READY_CLASS = 'section-header--ready';
  const HEADER_REVEAL_FALLBACK_MS = 5000;
  const headerRevealState = { layout: false };

  function getHeaderSectionNode() {
    return document.querySelector('.shopify-section.section-header');
  }

  function revealHeaderNavbar() {
    const section = getHeaderSectionNode();
    if (!section || section.classList.contains(HEADER_READY_CLASS)) return;
    section.classList.add(HEADER_READY_CLASS);
  }

  function tryRevealHeaderNavbar() {
    if (!headerRevealState.layout) return;
    revealHeaderNavbar();
  }

  function markHeaderLayoutReady() {
    if (headerRevealState.layout) return;
    headerRevealState.layout = true;
    tryRevealHeaderNavbar();
  }

  function scheduleHeaderRevealFallback() {
    if (window.__headerRevealFallbackScheduled) return;
    window.__headerRevealFallbackScheduled = true;
    window.setTimeout(revealHeaderNavbar, HEADER_REVEAL_FALLBACK_MS);
  }

  function notifyHeaderLayoutReady() {
    requestAnimationFrame(() => {
      requestAnimationFrame(markHeaderLayoutReady);
    });
  }

  function initHeaderAnnouncementLayout() {
    if (window.__headerAnnouncementLayoutInitialized) return;

    setupHeaderAnnouncementLayout();
    requestAnimationFrame(() => {
      setupHeaderAnnouncementLayout();
      notifyHeaderLayoutReady();
    });

    window.addEventListener(
      'scroll',
      () => {
        const siteHeaderGroup = getSiteHeaderGroup();
        const headerNode = resolveHeaderGroupSection(
          siteHeaderGroup?.querySelector('.shopify-section.section-header') ||
            siteHeaderGroup?.querySelector('.section-header')
        );
        updateHeaderAnnouncementScrollOffset(siteHeaderGroup, headerNode);
      },
      { passive: true }
    );
    window.addEventListener('resize', setupHeaderAnnouncementLayout);
    document.addEventListener('shopify:section:load', setupHeaderAnnouncementLayout);
    document.addEventListener('shopify:section:reorder', setupHeaderAnnouncementLayout);
    window.__headerAnnouncementLayoutInitialized = true;
  }

  document.addEventListener('DOMContentLoaded', syncHeaderAppearanceFromHero);
  document.addEventListener('DOMContentLoaded', setupHeaderScrollBackground);
  document.addEventListener('DOMContentLoaded', initHeaderAnnouncementLayout);
  document.addEventListener('DOMContentLoaded', scheduleHeaderRevealFallback);
  syncHeaderAppearanceFromHero();
  setupHeaderScrollBackground();
  initHeaderAnnouncementLayout();
  scheduleHeaderRevealFallback();
  document.addEventListener('shopify:section:load', syncHeaderAppearanceFromHero);
  document.addEventListener('shopify:section:reorder', syncHeaderAppearanceFromHero);

  } catch(e) { console.error(e); }
})();
})();
